<div class="dropdown-wrapper">
    <form [formGroup]="dynamicForm">
        <div formArrayName="filters">
            <div *ngFor="let filter of filters.controls; let i = index" [formGroupName]="i" class="field custom-field">

                <!-- Select Field -->
                <mat-form-field appearance="outline" class="field">
                    <mat-label>Select Field</mat-label>
                    <mat-select disableOptionCentering="true"  formControlName="selectedField" (selectionChange)="onFieldChange($event, i)">
                        <mat-option value="" disabled>Select Field</mat-option>
                        <mat-option *ngFor="let field of fields" [value]="field.name" [matTooltip]="field.displayName">{{ field.displayName
                            }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Check Condition (Operators based on Selected Field) -->
                <mat-form-field appearance="outline" class="field">
                    <mat-label>Check</mat-label>
                    <mat-select disableOptionCentering="true"  formControlName="selectedCheck" (selectionChange)="validateFilters()">
                        <mat-option value="" disabled>Select Check</mat-option>
                        <mat-option *ngFor="let check of getOperators(filter.value.selectedField)" [matTooltip]="check" [value]="check">
                            {{ check }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!--Select Dropdown Field -->
                <mat-form-field appearance="outline" class="field"
                    *ngIf="getMatFormType(filter.value.selectedField, 'isDropDown')">
                    <mat-label>Value</mat-label>
                    <mat-select disableOptionCentering="true"  formControlName="dropDownInputValue" (selectionChange)="validateFilters()" multiple>
                        <mat-option disabled>Value</mat-option>
                        <mat-option *ngFor="let opt of getValue(filter.value.selectedField)" [matTooltip]="opt" [value]="opt">
                            {{ opt }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Select Date Picker -->
                <mat-form-field appearance="outline" class="field"
                    *ngIf="getMatFormType(filter.value.selectedField, 'isDateField')">
                    <mat-label>Value</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="dateInputvalue"
                        placeholder="Choose a date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <!-- Select Input Value  -->
                <mat-form-field appearance="outline" class="field"
                    *ngIf="getMatFormType(filter.value.selectedField, 'isInputField')">
                    <mat-label>Value</mat-label>
                    <input matInput formControlName="inputValue" (input)="validateFilters()" placeholder="Value"
                        multiple>
                </mat-form-field>

                <!-- Remove Row Button -->
                <button *ngIf="filters.length > 1 && i != filters.length-1" class="btn btn-icon btn-prmy no-bg-btn"
                    style="margin-right: 8px; height:4rem;" (click)="removeFilter(i); $event.stopPropagation()"
                    matTooltip="Remove Column">
                    <i class="flaticon-delete" style="font-size: 17px;"></i>
                </button>

                <!-- Add New Row Button -->
                <button *ngIf="i === filters.length - 1" mat-icon-button class="add-button" (click)="addFilter()">
                    <mat-icon>add</mat-icon>
                </button>

            </div>
        </div>
    </form>
</div>